import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BiCalendar, BiHelpCircle, BiXCircle } from "react-icons/bi";
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { LoadingSpinner, validateEmail } from '../utils/uiUtils';
import configInfo from '../config/config.json';


const UserAdmin_NewUserView = props => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);

  const { user } = useContext(UserContext);
  const navigate = useNavigate();


  const [isSysAdminUser, setIsSysAdminUser] = useState(false);

  // API functions
  const [platformConfig, setPlatformConfig] = useState([]);
  const [deptList,       setDeptList]       = useState([]);

  function fetchPlatformConfig() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("platform-config");

        resolve(res.data);

        if (res.status === 200) {
          setPlatformConfig(res.data[0]);
        }
        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

/*
  const fetchDepts = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments");

        resolve(res.data);

        if (res.status === 200) {
          setDeptList(res.data);

          setNewDept(
            {
              id:       res.data[0].id,
              nameCode: res.data[0].nameCode
            }
          );
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }
*/

  const fetchDepts = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments");

        resolve(res.data);

        if (res.status === 200) {

          for (let i=0; i<res.data.length; i++) {
            res.data[i].displayName = [];
            res.data[i].displayName['en']    = res.data[i].name;
            res.data[i].displayName['zh_HK'] = res.data[i].nameLang2;
            res.data[i].displayName['zh_CN'] = res.data[i].nameLang3;
          }

          setDeptList(res.data);

          setNewDept(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // Update user info, all updatable fields, except password
  const createNewUser = () => {

    const reqBody = {
      username:         newUserInputs.username      ? newUserInputs.username.trim()      : newUserInputs.username,
      ...(!configInfo.appConfig.isPrimaryIdentProvider ?
      {password:        newUserInputs.password      ? newUserInputs.password.trim()      : newUserInputs.password} : {}),
      surname:          newUserInputs.surname       ? newUserInputs.surname.trim()       : newUserInputs.surname,
      givenName:        newUserInputs.givenName     ? newUserInputs.givenName.trim()     : newUserInputs.givenName,
      middleName:       newUserInputs.middleName    ? newUserInputs.middleName.trim()    : newUserInputs.middleName,
      fullNameLang2:    newUserInputs.fullNameLang2 ? newUserInputs.fullNameLang2.trim() : newUserInputs.fullNameLang2,
      fullNameLang3:    newUserInputs.fullNameLang3 ? newUserInputs.fullNameLang3.trim() : newUserInputs.fullNameLang3,
      displayName:      newUserInputs.displayName   ? newUserInputs.displayName.trim()   : newUserInputs.displayName,
      email:            newUserInputs.email         ? newUserInputs.email.trim()         : newUserInputs.email,
      mobilePhone:      newUserInputs.mobilePhone   ? newUserInputs.mobilePhone.trim()   : newUserInputs.mobilePhone,
      workPhone:        newUserInputs.workPhone     ? newUserInputs.workPhone.trim()     : newUserInputs.workPhone,
      userType:         (newUserType.key != null) ? newUserType.key : 'UTYPE_USER',
      accountType:      (newAccountType.key != null) ? newAccountType.key : 'USER',
      empId:            (newUserInputs && newUserInputs.empId) ? newUserInputs.empId.trim() : null,
      deptId:           (newDept && newDept.id) ? newDept.id : null,
      jobTitle:         (newUserInputs && newUserInputs.jobTitle) ? newUserInputs.jobTitle.trim() : null,
      mfaWithEmail:     newMfaWithEmail,
      mfaWithSMS:       newMfaWithSMS,
      language:         configInfo.uiConfig.visibleFields.USER_language ? newLng.key : 'en',
      activeStartTime:  (activeStartTime  ? activeStartTime.toISOString()  : ""),
      activeExpireTime: (activeExpireTime ? activeExpireTime.toISOString() : ""),
      externalId:       (newUserInputs && newUserInputs.externalId) ? newUserInputs.externalId : null
    }

    if (configInfo.appConfig.isSimpleUserCreation) {
      reqBody.password = password;
    }


    return new Promise(async (resolve, reject) => {

      setLoading(true); // For loading spinner

      try {

        // ##### TEMP HACK #####
        reqBody.userType = 'UTYPE_USER';

        const res = await axiosAuth_IDENT_MGMT_API.post("users", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          // props.onUIMode('LIST')
          navigate(-1);
        }

        setLoading(false);

      } catch (error) {
        if (error && error.response && error.response.data && (error.response.data.msg === 'ERR_Dup_unique_field')) {
          setErrMsg(t("I18N_ERR_New_user_dup"));
        } else {
          setErrMsg(t(translateAPIError(error)));
        }
        setLoading(false);
        return;
      }
    });
  }


  // UI Functions

  // Initialize state
  useEffect(() => {

    setIsSysAdminUser(user && user.userInfo && (user.userInfo.username === 'SYSTEM'));

    fetchPlatformConfig();
    fetchDepts();

    initFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const initFields = () => {
    setNewUserInputs({
      username: '',
      password: '',
      confirmPassword: '',
      userType: 'UTYPE_USER',
      empId: '',
      jobTitle: '',
      surname: '',
      givenName: '',
      middleName: '',
      fullNameLang2: '',
      fullNameLang3: '',
      displayName: '',
      email: '',
      mobilePhone: '',
      workPhone: '',
      externalId: ''
    });

    setNewUserType(
      userTypeList[0]
    );

/*
    setNewAccountType(
      accountTypeList[0]
    );

    setNewLng(
      lngList[0]
    );
*/
    // Dept list will be set in fetchDept()
  }

  const [newUserInputs, setNewUserInputs] = useState(
    {
      username: '',
      password: '',
      confirmPassword: '',
      empId: '',
      jobTitle: '',
      surname: '',
      givenName: '',
      middleName: '',
      fullNameLang2: '',
      fullNameLang3: '',
      displayName: '',
      email: '',
      mobilePhone: '',
      workPhone: '',
      externalId: ''
    }
  );

  const [newUserType,     setNewUserType]     = useState({});
  const [newAccountType,  setNewAccountType]  = useState({});
  const [newDept,         setNewDept]         = useState({});
  const [newMfaWithEmail, setNewMfaWithEmail] = useState(false);
  const [newMfaWithSMS,   setNewMfaWithSMS]   = useState(false);
  const [newLng,          setNewLng]          = useState({});

  const [activeStartTime,    setActiveStartTime]    = useState(null);
  const [activeExpireTime,   setActiveExpireTime]   = useState(null);

  let { username, password, confirmPassword, empId, jobTitle, surname, givenName, middleName,
        fullNameLang2, displayName, email, mobilePhone, workPhone, externalId } = newUserInputs;

  const [errMsg, setErrMsg] = useState('');

  const [loading, setLoading] = useState(false);


  // ##### Currently not in use #####
  const userTypeList = [
    { key: "UTYPE_USER",   value: "UTYPE_USER" },
    { key: "UTYPE_ADMIN",  value: "UTYPE_ADMIN" },
    { key: "UTYPE_APP",    value: "UTYPE_APP" },
    { key: "UTYPE_DEVICE", value: "UTYPE_DEVICE" }
  ];

  const accountTypeList = [
    ...(configInfo.appConfig.isPrimaryIdentProvider ?
   [{ key: "USER",      value: "USER" }] : []),
  //{ key: "SYS_ADMIN", value: "SYS_ADMIN" },   Remove for now since rarely needed.  If really needed, can update DB
    { key: "API",       value: "API" }
  ];

  const lngList = [
    { key: "en",    value: "en" },
    { key: "zh_CN", value: "zh_CN" },
    { key: "zh_HK", value: "zh_HK" }
  ];

/*
  const onUserTypeSelect = (key, event) => {
    setNewUserType({key: key, value: key});
  };
*/

  const onAccountTypeSelect = (key, event) => {
    setNewAccountType({key: key, value: key});
  };

  const onLngSelect = (key, event) => {
    setNewLng({key: key, value: key});
  };

  const onDeptClick = (id) => {
    setNewDept({id: id});
  };


  const onInputChange = (e) => {
    setNewUserInputs({ ...newUserInputs, [e.target.name]: e.target.value })
  }

  const onDatepickerChangeStart = (value) => {
    let newTime = (new Date(value)).getTime();
    let currentTime = (new Date()).getTime();

    // ### This check is not necessary, since the UI already built guardrail.  But keep it here for now. ###
    if (!value && (value != null) && (newTime < currentTime)) {
      setErrMsg(t("I18N_ERR_Date_must_be_future"));
    } else {
      setErrMsg(t(""));
      setActiveStartTime(value);
    }
  }

  const onDatepickerChangeUntil = (value) => {
    let newTime = (new Date(value)).getTime();
    let currentTime = (new Date()).getTime();

    // ### This check is not necessary, since the UI already built guardrail.  But keep it here for now. ###
    if (!value && (value != null) && (newTime < currentTime)) {
      setErrMsg(t("I18N_ERR_Date_must_be_future"));
    } else {
      setErrMsg(t(""));
      setActiveExpireTime(value);
    }
  }

  const handleNewUserCancel = (e) => {
    e.preventDefault();

    // Return to list
    // props.onUIMode('LIST')
    navigate(-1);
  }

  const handleNewUserSubmit = (e) => {
    e.preventDefault();

    validateUsername();
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateUsername() {

    if (!newUserInputs.username || newUserInputs.username.length === 0) {
      setErrMsg(t("I18N_ERR_Need_Username"));
      return;
    } else if (newUserInputs.username) {
      let regex = /^[a-zA-Z0-9_.@]{3,16}$/;

      if (!regex.test(newUserInputs.username)) {
        setErrMsg(t("I18N_ERR_Valid_username"));
        return;
      }
    }

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("users?username=" + newUserInputs.username);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
            setErrMsg(t("I18N_ERR_Dup_username"));
          return
        } else {
          validateOtherFields();
          return
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          validateOtherFields();
        }
      }
    });
  }


  function validateOtherFields() {
    // Validate form inputs

    if (!configInfo.appConfig.isPrimaryIdentProvider || configInfo.appConfig.isSimpleUserCreation) {
      if (!password || password.length === 0) {
        setErrMsg(t("I18N_ERR_Need_Password"));
        return;
      } else if (!validatePwdComplexity(password)) {
        setErrMsg(t("I18N_ERR_Poor_Password"));
        return;
      } else if (confirmPassword !== password) {
        setErrMsg(t("I18N_ERR_Pass_Mismatch"));
        return;
      }
    }

    if (configInfo.uiConfig.visibleFields.USER_language) {
      if (!newLng || !newLng.value || (newLng.value.length === 0)) {
        setErrMsg(t("I18N_ERR_Need_lng_pref"));
        return;
      }
    }

    if (   isSysAdminUser
        && (!newAccountType || !newAccountType.value || (newAccountType.value.length === 0))) {
      setErrMsg(t("I18N_ERR_Need_account_type"));
      return;
    }

    if (newUserInputs.jobTitle) {
      let regex = /^[a-zA-Z0-9()&-_.@ ]{2,80}$/;
      if (!regex.test(newUserInputs.jobTitle)) {
        setErrMsg(t("I18N_ERR_Valid_job_title"));
        return;
      }
    }

    if (newUserInputs.empId) {
      let regex = /^[a-zA-Z0-9-_.]{2,20}$/;
      if (!regex.test(newUserInputs.empId)) {
        setErrMsg(t("I18N_ERR_Valid_emp_id"));
        return;
      }
    }

    if (newUserInputs.externalId && newUserInputs.externalId.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + 30);
      return;
    }

    if (newUserInputs.surname && (newUserInputs.surname.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_surname") + 30);
      return;
    }

    if (newUserInputs.givenName && newUserInputs.givenName.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_given_name") + 30);
      return;
    }

    if (newUserInputs.middleName && newUserInputs.middleName.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_middle_name") + 30);
      return;
    }

    if (newUserInputs.fullNameLang2 && newUserInputs.fullNameLang2.length > 100) {
      setErrMsg(t("custom:I18N_ERR_Max_len_full_name_lang2") + 100);
      return;
    }

    /* For future enhancement
    if (newUserInputs.fullNameLang3 && newUserInputs.fullNameLang3.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_full_name_lang3") + 100);
      return;
    }
    */

    if (newUserInputs.displayName && newUserInputs.displayName.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_display_name") + 100);
      return;
    }

    if (   (configInfo.uiConfig.requiredFields.USER_email)
        && (!newUserInputs.email || newUserInputs.email.length === 0)) {
      setErrMsg(t("I18N_ERR_Need_Email"));
      return;
    }

    if (configInfo.uiConfig.validateFields.USER_email && newUserInputs.email.length > 0) {
      if (!validateEmail(newUserInputs.email)) {
        setErrMsg(t("I18N_ERR_Bad_Email"));
        return;
      } else if (newUserInputs.email && newUserInputs.email.length > 60) {
        setErrMsg(t("I18N_ERR_Max_len_email") + 60);
        return;
      }
    }

    if (newUserInputs.mobilePhone && configInfo.uiConfig.validateFields.USER_phone) {
      let regex = /^(?:\+852\s?)?[2-9]\d{7}$/;
      if (!regex.test(newUserInputs.mobilePhone)) {
        setErrMsg(t("I18N_ERR_Valid_mobile_phone"));
        return;
      }
    }

    if (newUserInputs.mobilePhone && newUserInputs.mobilePhone.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_mobile_phone") + 30);
      return;
    }

    if (newUserInputs.workPhone && configInfo.uiConfig.validateFields.USER_phone) {
      let regex = /^(?:\+852\s?)?[2-9]\d{7}$/;
      if (!regex.test(newUserInputs.workPhone)) {
        setErrMsg(t("I18N_ERR_Valid_work_phone"));
        return;
      }
    }

    if (newUserInputs.workPhone && newUserInputs.workPhone.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_work_phone") + 30);
      return;
    }

    setErrMsg('');
    createNewUser();
  }


  function validatePwdComplexity (password) {
    // Password policy: Min length, upper case, lower case, special char, etc.
    //let strongPassword = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+={\}[\]|\\:;"\'<>,.?/]).{12,30}$');
    let strongPassword = new RegExp(decodeURIComponent(platformConfig.config.public.pwdComplexity.testRegExp));

    if (!strongPassword.test(password)) {
      return (false);
    } else {
      return (true);
    }
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div className={classes.admin_pages__page_title}>
          {t("I18N_Create_New_User")}
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_General_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <Form>
              <Row className={classes.admin_pages__field_label}>
                <Col sm={3}>{t("I18N_Username")}: *</Col>
                { configInfo.uiConfig.visibleFields.USER_jobTitle ? <Col sm={3}>{t("I18N_Job_title")}:</Col>      : null }
                { configInfo.uiConfig.visibleFields.USER_dept     ? <Col sm={3}>{t("I18N_Dept_name")}:</Col>      : null }
{/*
                { configInfo.uiConfig.visibleFields.USER_userType ? <Col sm={3}>{t("I18N_User_type")}: *</Col>    : null }
*/}
                { isSysAdminUser ?                                  <Col sm={3}>{t("I18N_Account_type")}: *</Col> : null }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} name="username" value={username}
                    onChange={(e) => onInputChange(e)} />
                </Col>
                { configInfo.uiConfig.visibleFields.USER_jobTitle ?
                  <Col sm={3}>
                    <input className={classes.admin_pages__field_editable} name="jobTitle" value={jobTitle}
                      onChange={(e) => onInputChange(e)} />
                  </Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.USER_dept ?
                  <Col sm={3}>
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!newDept.id ? t("I18N_No_dept") :
                           (deptList.find( ({ id }) => id === parseInt(newDept.id) )).displayName[i18n.language]}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {deptList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.deptI} className={classes.dropdown_item_wrap} onClick={() => onDeptClick(item.id)}>
                              {item.displayName[i18n.language]}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                : null
                }
{/*
                { configInfo.uiConfig.visibleFields.USER_userType ?
                <Col sm={3}>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={t("common:I18N_" + newUserType.value)}
                    onSelect={onUserTypeSelect}>
                    {userTypeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("common:I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
                : null
                }
*/}
                { isSysAdminUser ?
                  <Col sm={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title= {!newAccountType.value ? t("common:I18N_DROPDOWN_PROMPT") : newAccountType.value}
                      onSelect={onAccountTypeSelect}>
                      {accountTypeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {item.value}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                : null
                }
              </Row>

              { configInfo.appConfig.isPrimaryIdentProvider ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    { configInfo.uiConfig.visibleFields.USER_language   ? <Col sm={3}>{t("I18N_Lng_pref")}: *</Col>  : null }
                    { configInfo.uiConfig.visibleFields.USER_empId      ? <Col sm={3}>{t("I18N_Emp_id")}:</Col>      : null }
                    { configInfo.uiConfig.visibleFields.USER_externalId ? <Col sm={3}>{t("I18N_External_id")}:</Col> : null }
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    { configInfo.uiConfig.visibleFields.USER_language ?
                      <Col sm={3}>
                        <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                          title= {!newLng.value ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_Lng_" + newLng.value)}
                          onSelect={onLngSelect}>
                          {lngList.map((item, index) => {
                            return (
                              <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                {t("I18N_Lng_" + item.value)}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Col>
                      : null
                    }
                    { configInfo.uiConfig.visibleFields.USER_empId ?
                      <Col sm={3}>
                        <input className={classes.admin_pages__field_editable} name="empId" value={empId}
                          onChange={(e) => onInputChange(e)} />
                      </Col>
                    : null
                    }
                    { configInfo.uiConfig.visibleFields.USER_externalId ?
                      <Col sm={3}>
                        <input className={classes.admin_pages__field_editable} name="externalId" value={externalId}
                          onChange={(e) => onInputChange(e)} />
                      </Col>
                    : null
                    }
                  </Row>
                </>
              :
                null
              }

              { configInfo.appConfig.isSimpleUserCreation ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={3}>{t("I18N_Password")}: *</Col>
                    <Col sm={3}>{t("I18N_Confirm_password")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col sm={3}>
                      <input className={classes.admin_pages__field_editable} name="password" value={password}
                        onChange={(e) => onInputChange(e)} />
                      { platformConfig && platformConfig.config ?
                          <OverlayTrigger overlay={<Tooltip id="tooltip-pwd-complexity" style={{fontSize:'11px'}}>
                                                     { i18n.language === 'en'    ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en)    :
                                                       i18n.language === 'zh_HK' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_HK) :
                                                       i18n.language === 'zh_CN' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_CN) :
                                                       decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en) }
                                                   </Tooltip>}>
                            <span style={{marginLeft:'5px', cursor:'pointer'}}>
                              <BiHelpCircle size={15} />
                            </span>
                          </OverlayTrigger>
                        : null
                      }
                    </Col>
                    <Col sm={3}>
                      <input className={classes.admin_pages__field_editable} name="confirmPassword" value={confirmPassword}
                        onChange={(e) => onInputChange(e)} />
                    </Col>
                  </Row>
                </>
              : null
              }

            </Form>
          </Container>
        </div>

        { configInfo.uiConfig.visibleFields.USER_surname || configInfo.uiConfig.visibleFields.USER_givenName || configInfo.uiConfig.visibleFields.USER_middleName ?
        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_User_name")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form style={{ borderColor: 'lightgray' }}>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '15px' }}>
                <Col>{t("I18N_Surname")}:</Col>
                <Col>{t("I18N_Given_name")}:</Col>
                <Col>{t("I18N_Middle_name")}:</Col>
                <Col />
              </Row>
              <Row >
                <Col>
                  <input className={classes.admin_pages__field_editable} name="surname" value={surname}
                    onChange={(e) => onInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} name="givenName" value={givenName}
                    onChange={(e) => onInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} name="middleName" value={middleName}
                    onChange={(e) => onInputChange(e)} />
                </Col>
                <Col />
              </Row>

              { configInfo.uiConfig.visibleFields.USER_fullNameLang2 || configInfo.uiConfig.visibleFields.USER_displayName ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '15px' }}>
                    { configInfo.uiConfig.visibleFields.USER_fullNameLang2 ? <Col sm={3}>{t("custom:I18N_Full_name_lang2")}:</Col> : null }
                    { configInfo.uiConfig.visibleFields.USER_displayName   ? <Col sm={3}>{t("common:I18N_Display_name")}:   </Col> : null }
                  </Row>
                  <Row >
                    { configInfo.uiConfig.visibleFields.USER_fullNameLang2 ?
                        <Col sm={3}>
                          <input className={classes.admin_pages__field_editable} name="fullNameLang2" value={fullNameLang2}
                            onChange={(e) => onInputChange(e)} />
                        </Col>
                    : null
                    }
                    { configInfo.uiConfig.visibleFields.USER_displayName ?
                        <Col sm={3}>
                          <input className={classes.admin_pages__field_editable} name="displayName" value={displayName}
                            onChange={(e) => onInputChange(e)} />
                        </Col>
                    : null
                    }
                  </Row>
                </>
              : null
              }

            </form>
          </Container>
        </div>
        : null
        }

        { configInfo.uiConfig.visibleFields.USER_email || configInfo.uiConfig.visibleFields.USER_mobilePhone || configInfo.uiConfig.visibleFields.USER_workPhone ?
        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_Contact_info")}
            </span>

          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                { configInfo.uiConfig.visibleFields.USER_email       ?
                    <Col sm={3}>{t("I18N_Email")}:{configInfo.uiConfig.requiredFields.USER_email ? ' *' : null}</Col> : null }
                { configInfo.uiConfig.visibleFields.USER_mobilePhone ? <Col sm={3}>{t("I18N_Mobile_phone")}:</Col>    : null }
                { configInfo.uiConfig.visibleFields.USER_workPhone   ? <Col sm={3}>{t("I18N_Work_phone")}:</Col>      : null }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                { configInfo.uiConfig.visibleFields.USER_email       ?
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="email" value={email}
                      onChange={(e) => onInputChange(e)} />
                  </Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.USER_mobilePhone ?
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="mobilePhone" value={mobilePhone}
                      onChange={(e) => onInputChange(e)} />
                  </Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.USER_workPhone   ?
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="workPhone" value={workPhone}
                      onChange={(e) => onInputChange(e)} />
                </Col>
                : null
                }
                <Col />
              </Row>
            </form>
          </Container>
        </div>
        : null
        }


        { configInfo.uiConfig.visibleFields.USER_mfa ?
        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_User_auth")}
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <div style={{ marginTop: '8px' }}>
              <div display='flex'>
                <span className={classes.admin_pages__field_label}>
                  {t("I18N_MFA")}
                </span>
              </div>

              <Form className={classes.admin_pages__field_value} style={{ margin: '10px 0 0 10px' }}>
                <Form.Check
                  type="switch"
                  id="mfa-email"
                  label={t("I18N_MFA_via_email")}
                  checked={newMfaWithEmail}
                  onChange={() => {
                    setNewMfaWithEmail(!newMfaWithEmail)
                  }}
                />
{ false ?
                <Form.Check
                  type="switch"
                  id="mfa-sms"
                  label={t("I18N_MFA_via_sms")}
                  checked={newMfaWithSMS}
                  onChange={() => {
                    setNewMfaWithSMS(!newMfaWithSMS)
                  }}
                />
: null
}
              </Form>

            </div>
          </Container>
        </div>
        : null
        }


        { configInfo.uiConfig.visibleFields.USER_activeTimeWindow ?
        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_User_active_window")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form style={{ borderColor: 'lightgray' }}>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '15px' }}>
                <Col>{t("I18N_User_active_start")}:</Col>
                <Col>{t("I18N_User_active_expire")}:</Col>
                <Col></Col>
              </Row>
              <Row >
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeStart} value={activeStartTime}
/*
                     format={ (activeStartTime != null) ? "y-MM-dd h:00 a" : "y-MM-dd h:-- a" }
*/
                     format={ (activeStartTime != null) ? "y-MM-dd h a" : "y-MM-dd h a" }
                     minDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                     disableClock="true"
                     clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                     calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                     /* Note: zh-CN has a bug: AM/PM is shown in English, so using zh-HK for now */
                     locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-HK" : "en")}
                  />
                </Col>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeUntil} value={activeExpireTime}
/*
                     format={ (activeExpireTime != null) ? "y-MM-dd h:00 a" : "y-MM-dd h:-- a" }
*/
                     format={ (activeExpireTime != null) ? "y-MM-dd h a" : "y-MM-dd h a" }
                     minDate={ activeStartTime? activeStartTime: new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                     disableClock="true"
                     clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                     calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                     /* Note: zh-CN has a bug: AM/PM is shown in English, so using zh-HK for now */
                     locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-HK" : "en")}
                  />
                </Col>
                <Col>
                </Col>
              </Row>
            </form>
          </Container>
        </div>
        : null
        }

        <hr className="solid" style={{ marginTop: '20px' }}></hr>

        <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
          <span>{t("I18N_Req_fields")}</span>
        </Row>

        <Row>
          <Col md={2}>
            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleNewUserCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleNewUserSubmit}>
                {t("I18N_Submit")}
              </Button>
            </div>
          </Col>
          <Col md={10} style={{marginTop:'15px'}}>
            <span className={classes.admin_pages__field_label} style={{color:'rgba(200,0,0)', verticalAlign:'top'}}>
              {errMsg}
            </span>
          </Col>
        </Row>

        <LoadingSpinner loading={loading} />
      </Card>
    </>
  );
}

export default UserAdmin_NewUserView;
